var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer" }, [
    _c("div", { staticClass: "footer-bottom-wrap" }, [
      _c("div", { staticClass: "footer-bottom clearfix" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "inner-right float-right" }, [
          _c("div", { staticClass: "ssj-service" }, [
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("p"),
            _vm._v(" "),
            _c("p"),
            _vm._v(" "),
            _c("p"),
            _vm._v(" "),
            _c("p"),
            _vm._v(" "),
            _c("p"),
            _vm._v(" "),
            _c("p"),
            _vm._v(" "),
            _c("p", { staticClass: "certification" }, [_vm._v("安全认证")]),
            _vm._v(" "),
            _c("div", { staticClass: "certificate-security clearfix" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "link-wj float-left" }, [
                _c(
                  "a",
                  {
                    key: "5a14e43a12c3d57854cc3223",
                    staticClass: "certification_img certification_img_width",
                    attrs: {
                      logo_size: "124x47",
                      logo_type: "official",
                      href:
                        "https://v.pinpaibao.com.cn/authenticate/cert/?site=www.sui.com&at=official",
                      target: "_blank"
                    }
                  },
                  [
                    _c("img", {
                      staticStyle: { border: "none" },
                      attrs: {
                        width: "100",
                        src: "https://res.sui.com/img/index/gw_124x47.png",
                        alt: "安全联盟认证"
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._m(4)
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "float-left qrcode-content" }, [
      _c("img", {
        attrs: { src: require("../../assets/img/footer/footer-qrcode.jpg") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", [_vm._v("客服电话:")]),
      _vm._v(" ( 工作日9:00-18:00 )")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("em", { staticClass: "tel" }, [
      _c("a", { attrs: { href: "tel:400-698-801" } }, [
        _c("img", {
          attrs: {
            src: require("../../assets/img/footer/footer-tel.png"),
            width: "27",
            height: "25"
          }
        }),
        _vm._v(
          "\n                            400-698-8018\n                        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "link-wj float-left" }, [
      _c(
        "a",
        {
          attrs: {
            href:
              "https://szcert.ebs.org.cn/b4342f7c-8a31-4ab3-bffe-725f37fae32b",
            target: "_blank"
          }
        },
        [
          _c("img", {
            staticStyle: { "border-width": "0px", border: "none" },
            attrs: {
              src: "https://szcert.ebs.org.cn/Images/govIcon.gif",
              title: "深圳市市场监督管理局企业主体身份公示",
              alt: "深圳市市场监督管理局企业主体身份公示",
              width: "36",
              height: "50",
              border: "0"
            }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("网站备案编号："),
      _c(
        "a",
        { attrs: { href: "http://beian.miit.gov.cn", target: "blank" } },
        [_vm._v("粤ICP备12051031号")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ba7adc1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ba7adc1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navFooter/index.vue
// module id = 640
// module chunks = 36